import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    TaxClassificationEnum,
} from 'app/enums/label.enums'

import {
    BillingCompany,
} from '../../BillingCompanyForm.types'

const getSalesAreaTaxFields = (
    getAllowedValues: (enumType: any) => Record<string, string>,
): DTOCardFormField<keyof BillingCompany> => {
    return {
        id: 'salesAreaTax',
        title: 'Sales Area Tax',
        className: 'salesAreaTax',
        'data-testid': 'card-salesAreaTax',
        fields: [{
            name: 'taxClassification',
            componentName: 'EnumSelector',
            allowedValues: getAllowedValues(TaxClassificationEnum),
            required: true,
            useDropdown: true,
            labelKey: 'BillingCompanyView.taxClassification',
        }],
    }
}

export default getSalesAreaTaxFields
